//const URL_SERVIDOR = "http://127.0.0.1:8000/public/imagenes/archivos/";
const URL_SERVIDOR = "http://127.0.0.1:8000/api/";
export default URL_SERVIDOR;